import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import LoadingSpinner from "./LoadingSpinner";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullScreen text="Checking your session..." />;
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{
          reason:
            sessionStorage.getItem("sessionExpired") === "1"
              ? "session-expired"
              : undefined,
          from: location,
        }}
        replace
      />
    );
  }

  if (adminOnly && user.role !== "Admin") {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
